import { render, staticRenderFns } from "./session-professional-area-selector.vue?vue&type=template&id=e43581d0"
import script from "./session-professional-area-selector.vue?vue&type=script&lang=ts"
export * from "./session-professional-area-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports